<template>
  <page>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="newMode">mdi-plus</v-icon>
        <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
        <v-icon v-else>mdi-pencil</v-icon>
        <v-toolbar-title v-if="newMode">Create New Block Treaty Limit</v-toolbar-title>
        <v-toolbar-title v-else-if="queryMode">Query Block Treaty Limit</v-toolbar-title>
        <v-toolbar-title v-else>Edit Block Treaty Limit</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container grid-list-md>
          <v-layout row wrap>
            <!-- accumType -->
            <v-flex xs6 v-if="newMode">
              <v-autocomplete
                :items="accmTypeList"
                v-model="form.accmType"
                :label="labels.accmType"
                :error-messages="errors.collect('accmType')"
                item-text="label"
                item-value="value"
                data-vv-name="accmType"
                :data-vv-as="labels.accmType"
                @change="setValue()"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.accmType }}</v-subheader>
              <div class="queryValue">{{ getDesc(form.accmType) }}</div>
            </v-flex>
            <!-- blkGrp -->
            <v-flex xs6 v-if="newMode">
              <v-text-field
                v-model="form.blkGrp"
                :label="labels.blkGrp"
                :error-messages="errors.collect('blkGrp')"
                data-vv-name="blkGrp"
                :data-vv-as="labels.blkGrp"
                append-icon="mdi-magnify"
                @click:append="getHelpList('blkGrp')"
                v-validate="validateBlkGrp"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blkGrp }}</v-subheader>
              <div class="queryValue">{{ form.blkGrp }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <!-- blkS1grp -->
            <v-flex xs6 v-if="newMode">
              <v-text-field
                v-model="form.blkS1grp"
                :label="labels.blkS1grp"
                :error-messages="errors.collect('blkS1grp')"
                data-vv-name="blkS1grp"
                :data-vv-as="labels.blkS1grp"
                append-icon="mdi-magnify"
                @click:append="getHelpList('blkS1grp')"
                v-validate="validateBlkS1grp"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blkS1grp }}</v-subheader>
              <div class="queryValue">{{ form.blkS1grp }}</div>
            </v-flex>
            <!-- blkS2grp -->
            <v-flex xs6 v-if="newMode">
              <v-text-field
                v-model="form.blkS2grp"
                :label="labels.blkS2grp"
                :error-messages="errors.collect('blkS2grp')"
                data-vv-name="blkS2grp"
                :data-vv-as="labels.blkS2grp"
                append-icon="mdi-magnify"
                @click:append="getHelpList('blkS2grp')"
                v-validate="validateBlkS2grp"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blkS2grp }}</v-subheader>
              <div class="queryValue">{{ form.blkS2grp }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <!-- blk -->
            <v-flex xs6 v-if="newMode">
              <v-text-field
                v-model="form.blk"
                :label="labels.blk"
                :error-messages="errors.collect('blk')"
                data-vv-name="blk"
                :data-vv-as="labels.blk"
                append-icon="mdi-magnify"
                @click:append="getHelpList('blk')"
                v-validate="validateBlk"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blk }}</v-subheader>
              <div class="queryValue">{{ form.blk }}</div>
            </v-flex>
            <!-- riType -->
            <v-flex xs6 v-if="newMode">
              <v-autocomplete
                :items="riTypeList"
                v-model="form.riType"
                :label="labels.riType"
                item-text="label"
                item-value="value"
                data-vv-name="riType"
                :data-vv-as="labels.riType"
                :error-messages="errors.collect('riType')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.riType }}</v-subheader>
              <div class="queryValue" v-for="item in filterRiTypeList" :key="item.value">{{ item.label }}</div>
            </v-flex>
          </v-layout>
          <!-- ttyNo -->
          <v-layout row wrap v-if="newMode">
            <v-flex xs6>
              <v-text-field
                readonly
                v-model="form.ttyNo"
                :label="labels.ttyNo"
                :error-messages="errors.collect('ttyNo')"
                data-vv-name="ttyNo"
                :data-vv-as="labels.ttyNo"
                v-validate="validateTtyNo"
                append-icon="mdi-magnify"
                @click:append="getHelpList('ttyNo')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-show="ttyNoDescFromHelpList != undefined && ttyNoDescFromHelpList != ''">
              <v-subheader class="queryLabel">{{ labels.ttyNoDescFromHelpList }}</v-subheader>
              <div class="queryValue">{{ ttyNoDescFromHelpList }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.ttyNo }}</v-subheader>
              <div class="queryValue">{{ form.ttyNo }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.ttyNoDescFromDB }}</v-subheader>
              <div class="queryValue">{{ ttyNoDescFromDB }}</div>
            </v-flex>
          </v-layout>
          <!-- acctNoSfx -->
          <v-layout row wrap v-if="newMode">
            <v-flex xs6>
              <v-text-field
                readonly
                v-model="form.acctNoSfx"
                :label="labels.acctNoSfx"
                :error-messages="errors.collect('acctNoSfx')"
                data-vv-name="acctNoSfx"
                :data-vv-as="labels.acctNoSfx"
                append-icon="mdi-magnify"
                @click:append="getHelpList('acctNoSfx')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-show="acctNoSfxDescFromHelpList != undefined && acctNoSfxDescFromHelpList != ''">
              <v-subheader class="queryLabel">{{ labels.acctNoSfxDescFromHelpList }}</v-subheader>
              <div class="queryValue">{{ acctNoSfxDescFromHelpList }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
              <div class="queryValue">{{ form.acctNoSfx }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.acctNoSfxDescFromDB }}</v-subheader>
              <div class="queryValue">{{ acctNoSfxDescFromDB }}</div>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs6 v-if="!queryMode">
              <v-text-field
                v-model="form.noLines"
                :label="labels.noLines"
                :error-messages="errors.collect('noLines')"
                data-vv-name="noLines"
                :data-vv-as="labels.noLines"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.noLines }}</v-subheader>
              <div class="queryValue">{{ form.noLines }}</div>
            </v-flex>
            <v-flex xs6 v-if="!queryMode">
              <v-text-field
                ref="esclPct"
                v-model="form.esclPct"
                :label="labels.esclPct"
                :error-messages="errors.collect('esclPct')"
                data-vv-name="esclPct"
                :data-vv-as="labels.esclPct"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                @blur="setDec"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.esclPct }}</v-subheader>
              <div class="queryValue">{{ form.esclPct }}</div>
            </v-flex>
            <v-flex xs6 v-if="!queryMode">
              <v-text-field
                ref="ttyLim"
                v-model="form.ttyLim"
                :label="labels.ttyLim"
                :error-messages="errors.collect('ttyLim')"
                data-vv-name="ttyLim"
                :data-vv-as="labels.ttyLim"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                @blur="setDec"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.ttyLim }}</v-subheader>
              <div class="queryValue">{{ form.ttyLim }}</div>
            </v-flex>
          </v-layout>

          <v-layout wrap v-show="show">
            <v-flex xs6 v-if="newMode">
              <v-text-field
                disabled
                v-model="form.limType"
                :label="labels.limType"
                :error-messages="errors.collect('limType')"
                data-vv-name="limType"
                :data-vv-as="labels.limType"
                v-validate="'required'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.limType }}</v-subheader>
              <div class="queryValue">{{ form.limType }}</div>
            </v-flex>
            <v-flex xs6 v-if="!queryMode">
              <v-text-field
                ref="ownRtn"
                disabled
                v-model="form.ownRtn"
                :label="labels.ownRtn"
                :error-messages="errors.collect('ownRtn')"
                data-vv-name="ownRtn"
                :data-vv-as="labels.ownRtn"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                @blur="setDec"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.ownRtn }}</v-subheader>
              <div class="queryValue">{{ form.ownRtn }}</div>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ form.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(form.createdDate) }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="!newMode">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ form.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(form.modifiedDate) }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
          Cancel
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" dark class=" mr-2" v-if="!queryMode" @click.native="doSave">
          {{ newMode ? 'Save' : 'Save' }}
          <v-icon right>{{ newMode ? 'mdi-content-save' : 'mdi-content-save' }}</v-icon>
        </v-btn>
      </v-card-actions>
      <v-dialog v-model="helplist" width="800px" persistent>
        <blk-grp-helplist v-if="blkGrpHelplist" :accmType="form.accmType" @close="doCloseHelplist" @doAssign="doAssign1($event)"></blk-grp-helplist>
        <blks-grp1-helplist v-if="blksGrp1Helplist" :blkGrpId="blkGrpId" @close="doCloseHelplist" @doAssign="doAssign2($event)"></blks-grp1-helplist>
        <blks-grp2-helplist
          v-if="blksGrp2Helplist"
          :blksGrpId="blksGrpId"
          @close="doCloseHelplist"
          @doAssign="doAssign3($event)"
        ></blks-grp2-helplist>
        <blk-help-list v-if="blkHelplist" :blksGrpId="blksGrpId" @close="doCloseHelplist" @doAssign="doAssign4($event)"></blk-help-list>
      </v-dialog>
      <v-dialog v-model="ttyList" width="900px" persistent>
        <tty-no-help-list v-if="ttyNoHelplist" :riType="form.riType" @close="doCloseHelplist" @doAssign="doAssign($event)"></tty-no-help-list>
      </v-dialog>
      <v-dialog v-model="acctNoSfxList" width="900px" persistent>
        <acct-no-sfx-helplist v-if="acctNoSfxHelpList" @close="doCloseHelplist" @doAssign="doAssign($event)"></acct-no-sfx-helplist>
      </v-dialog>
    </v-card>
    <v-divider></v-divider>
  </page>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import BlkGrpHelplist from '../BlockGroupHelplist'
import BlksGrp1Helplist from '../BlockSubGroup1Helplist'
import BlksGrp2Helplist from '../BlockSubGroup2Helplist'
import BlkHelpList from './BlkHelpList'
import TtyNoHelpList from './TtyNoHelpList.vue'
import AcctNoSfxHelplist from './AcctNoSfxHelplist'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'

export default {
  props: ['mode', 'id'],
  data() {
    return {
      show: false,
      labels: {
        accmType: 'Accumulation Type',
        blk: 'Block',
        blkGrp: 'Block Group',
        blkS1grp: 'Block Sub Group 1',
        blkS2grp: 'Block Sub Group 2',
        riType: 'RI Type',
        ttyNo: 'Treaty No.',
        ttyNoDescFromHelpList: 'Treaty Name',
        ttyNoDescFromDB: 'Treaty Name',
        acctNoSfx: 'Account No. Suffix',
        acctNoSfxDescFromHelpList: 'Account No. Suffix Description',
        acctNoSfxDescFromDB: 'Account No. Suffix Description',
        noLines: 'No. of Lines',
        esclPct: 'Escalation %',
        ttyLim: 'Treaty Limits',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        limType: 'Limit Type',
        ownRtn: 'Own Retention'
      },
      form: {
        accmType: null,
        blkGrp: null,
        blkS1grp: null,
        blkS2grp: null,
        blk: null,
        riType: null,
        ttyNo: null,
        acctNoSfx: null,
        acct: null,
        noLines: '0',
        esclPct: '0.00',
        ttyLim: '0.00',
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedBy: '',
        modifiedDate: null,
        limType: undefined,
        ownRtn: '0.00'
      },
      riTypeList: [
        { label: 'C - Coinsurance', value: 'C' },
        { label: 'D - Statutory', value: 'D' },
        { label: 'F - Facultative', value: 'F' },
        { label: 'T - Treaty', value: 'T' },
        { label: 'W - Quota Share', value: 'W' }
      ],
      blkGrpId: {},
      blksGrpId: {},
      inter: {},
      helplist: false,
      blkGrpHelplist: false,
      blksGrp1Helplist: false,
      blksGrp2Helplist: false,
      blkHelplist: false,
      ttyNoHelplist: false,
      ttyList: false,
      acctNoSfxList: false,
      acctNoSfxHelpList: false,
      newMode: false,
      queryMode: false,
      accmTypeList: [],
      submitting: false,
      ttyNoDescFromHelpList: '',
      ttyNoDescFromDB: '',
      acctNoSfxDescFromHelpList: '',
      acctNoSfxDescFromDB: '',
      validateBlkGrp: '',
      validateBlkS1grp: '',
      validateBlkS2grp: '',
      validateBlk: '',
      validateTtyNo: 'required'
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    },
    filterRiTypeList() {
      return this.riTypeList.filter((list) => {
        return list.value === this.form.riType
      })
    }
  },
  watch: {
    mode: function (value) {
      this.doInit()
    },
    watch: {
      'form.riType': function (newVal, oldVal) {
        if (this.newMode) {
          // check if newMode to prevent the data set in query/review mode to be changed
          if (newVal !== oldVal || newVal === '') {
            // if riType is changed, and is NOT Equal to Old Value
            // or it's empty (requires to backspace 3 times even if it's blank)
            this.form.riCo = ''
            this.riCoDescFromHelpList = ''
          }
        }
      }
    },
    'form.ttyNo': function (value) {
      if (this.newMode) {
        if (this.form.ttyNo !== '') {
          this.$validator.validate('ttyNo')
        } else {
          this.validateTtyNo = 'required'
        }
      }
    }
  },
  methods: {
    async doInit() {
      if (this.mode === 'new') {
        this.newMode = true
        this.queryMode = false
      } else {
        const apiURI = this.menu.getBlkTtyLim
        if (apiURI) {
          try {
            const expand = {
              accmType: this.id.accmType,
              blk: this.id.blk,
              blkGrp: this.id.blkGrp,
              blkS1grp: this.id.blksGrp1,
              blkS2grp: this.id.blksGrp2,
              limType: this.id.limType,
              riType: this.id.riType,
              ttyNo: this.id.ttyNo,
              acctNoSfx: this.id.acctNoSfx
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.form.accmType = data.blkTL.accmType
              this.form.blkGrp = data.blkTL.blkGrp + ' - ' + data.blkGrpDesc
              this.form.blkS1grp = data.blkTL.blkS1grp + ' - ' + data.blkS1GrpDesc
              this.form.blkS2grp = data.blkTL.blkS2grp + ' - ' + data.blkS2GrpDesc
              this.form.blk = data.blkTL.blk + ' - ' + data.blkDesc
              this.form.riType = data.blkTL.riType
              this.form.ttyNo = data.blkTL.ttyNo
              this.ttyNoDescFromDB = data.ttyNoDesc
              this.form.acctNoSfx = data.blkTL.acctNoSfx
              this.acctNoSfxDescFromDB = data.acctNoSfxDesc
              this.form.noLines = data.blkTL.noLines
              this.form.esclPct = formatPrice(Number(removeFormatNumber(data.blkTL.esclPct)))
              this.form.ttyLim = formatPrice(Number(removeFormatNumber(data.blkTL.ttyLim)))
              this.form.limType = data.blkTL.limType
              this.form.ownRtn = formatPrice(Number(removeFormatNumber(data.blkTL.ownRtn)))
              this.form.createdBy = data.createdBy
              this.form.creadtedDate = data.createdDate
              this.form.modifiedBy = data.modifiedBy
              this.form.modifiedDate = data.modifiedDate
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
        this.setValue()
        if (this.mode === 'edit') {
          this.newMode = false
          this.queryMode = false
        } else {
          this.newMode = false
          this.queryMode = true
        }
      }
    },
    getDesc(id) {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === id) {
          return this.accmTypeList[i].label
        }
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType,
              blkGrpLblS: accmType.blkGrpLblS,
              blksGrp1LblS: accmType.blkSgrp1LblS,
              blksGrp2LblS: accmType.blkSgrp2LblS,
              blkLblS: accmType.blkLblS,
              defBlkAE: accmType.defBlkAE,
              nxtBlkSeq: accmType.nxtBlkSeq
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    setValue() {
      this.$validator.reset()
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === this.form.accmType) {
          if (this.accmTypeList[i].blkGrpLblS !== undefined) {
            this.validateBlkGrp = 'required'
            this.labels.blkGrp = this.accmTypeList[i].blkGrpLblS
          } else {
            this.validateBlkGrp = ''
            this.labels.blkGrp = undefined
          }
          if (this.accmTypeList[i].blksGrp1LblS !== undefined) {
            this.validateBlkS1grp = 'required'
            this.labels.blkS1grp = this.accmTypeList[i].blksGrp1LblS
          } else {
            this.validateBlkS1grp = ''
            this.labels.blkS1grp = undefined
          }
          if (this.accmTypeList[i].blksGrp2LblS !== undefined) {
            this.validateBlkS2grp = 'required'
            this.labels.blkS2grp = this.accmTypeList[i].blksGrp2LblS
          } else {
            this.validateBlkS2grp = ''
            this.labels.blkS2grp = undefined
          }
          if (this.accmTypeList[i].blkLblS !== undefined) {
            this.validateBlk = 'required'
            this.labels.blk = this.accmTypeList[i].blkLblS
          } else {
            this.validateBlk = ''
            this.labels.blk = undefined
          }
          if (this.newMode) {
            this.form.blkGrp = ''
            this.form.blkS1grp = ''
            this.form.blkS2grp = ''
            this.form.blk = ''
          }
        }
      }
    },
    setDec() {
      this.$refs.esclPct.$el.cleave.setRawValue(this.form.esclPct)
      this.form.esclPct = formatPrice(this.$refs.esclPct.$el.cleave.getRawValue())
      this.$refs.ttyLim.$el.cleave.setRawValue(this.form.ttyLim)
      this.form.ttyLim = formatPrice(this.$refs.ttyLim.$el.cleave.getRawValue())
      this.$refs.ownRtn.$el.cleave.setRawValue(this.form.ownRtn)
      this.form.ownRtn = formatPrice(this.$refs.ownRtn.$el.cleave.getRawValue())
    },
    getHelpList(field) {
      if (field === 'blkGrp') {
        this.blkGrpHelplist = true
      } else if (field === 'blkS1grp') {
        this.blkGrpId.accmType = this.form.accmType
        this.blkGrpId.blkGrp = this.form.blkGrp
        this.blksGrp1Helplist = true
      } else if (field === 'blkS2grp') {
        this.blksGrpId.accmType = this.form.accmType
        this.blksGrpId.blkGrp = this.form.blkGrp
        this.blksGrpId.blksGrp1 = this.form.blkS1grp
        this.blksGrp2Helplist = true
      } else if (field === 'blk') {
        this.blksGrpId.accmType = this.form.accmType
        this.blksGrpId.blkGrp = this.form.blkGrp
        this.blksGrpId.blksGrp1 = this.form.blkS1grp
        this.blksGrpId.blksGrp2 = this.form.blkS2grp
        this.blkHelplist = true
      } else if (field === 'ttyNo') {
        this.ttyNoHelplist = true
        this.ttyList = true
      } else if (field === 'acctNoSfx') {
        this.acctNoSfxHelpList = true
        this.acctNoSfxList = true
      }
      this.helplist = true
    },
    doCloseHelplist() {
      this.blkGrpHelplist = false
      this.blksGrp1Helplist = false
      this.blksGrp2Helplist = false
      this.blkHelplist = false
      this.ttyNoHelplist = false
      this.ttyList = false
      this.acctNoSfxHelpList = false
      this.acctNoSfxList = false
      this.helplist = false
    },
    doAssign1(blkGrp) {
      this.form.blkGrp = blkGrp
      this.$validator.validate('blkGrp')
    },
    doAssign2(blkS1grp) {
      this.form.blkS1grp = blkS1grp
      this.$validator.validate('blkS1grp')
    },
    doAssign3(blkS2grp) {
      this.form.blkS2grp = blkS2grp
      this.$validator.validate('blkS2grp')
    },
    doAssign4(blk) {
      this.form.blk = blk
      this.$validator.validate('blk')
    },
    doAssign(Obj) {
      if (Obj.from === 'inter') {
        this.form.ttyNo = Obj.ttyNo.inter
        this.ttyNoDescFromHelpList = Obj.ttyNo.name1
      }
      if (Obj.from === 'treaty') {
        this.form.ttyNo = Obj.ttyNo.ttyNo
        this.ttyNoDescFromHelpList = Obj.ttyNo.ttyDesc
      }
      if (Obj.from === 'acctNoSfx') {
        this.form.acctNoSfx = Obj.acctNoSfx.acctNoSfx
        this.acctNoSfxDescFromHelpList = Obj.acctNoSfx.description
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createBlkTtyLim
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'blkTtyLim' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateBlkTtyLim
      if (apiURI) {
        this.submitting = true
        try {
          this.form.ttyLim = removeFormatNumber(this.form.ttyLim)
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'blkTtyLim' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'blkTtyLim' })
    }
  },
  async created() {
    await this.getAccmTypeList()
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    BlkGrpHelplist,
    BlksGrp1Helplist,
    BlksGrp2Helplist,
    BlkHelpList,
    TtyNoHelpList,
    AcctNoSfxHelplist
  }
}
</script>
